import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import ic_filter from '../../assets/ic_filter.svg'


const FTULandingPageVehicleData = (props) => {


  const [rowData, setRowData] = useState([]);
  const [sortBy, setSortBy] = useState();

  

  useEffect(() => {
    console.log("res:::2", props.vehicleDeviceCombinationFilterData);
  
    const resources = Array.isArray(props.vehicleDeviceCombinationFilterData)
      ? props.vehicleDeviceCombinationFilterData
      : [];
  
    if (resources.length === 0) {
      setRowData([]);
      return;
    }
  
    const isAsc = sortBy === "asc"; // follow the same logic as first snippet
  
    const groupedData = resources
      .map(resource => {
        const selectedProgramManager = resource.sDreambigTitle;
        const ftcCount = resource?.distinct_mobile_count || 0;
        const vehicleData = resource.answer_breakdown || [];
  
        // Sort subtype breakdown
        const sortedVehicleBreakdown = [...vehicleData].sort((a, b) =>
          isAsc
            ? (a.answer_count || 0) - (b.answer_count || 0)
            : (b.answer_count || 0) - (a.answer_count || 0)
        );
  
        return {
          programManager: selectedProgramManager,
          ftc: ftcCount,
          partners: [
            {
              partner: "-",
              vehicleBreakdown: sortedVehicleBreakdown.map(item => ({
                type: item.sAnswer,
                count: item.answer_count
              })),
              resources: []
            }
          ],
          totalVehicles: sortedVehicleBreakdown.reduce(
            (sum, v) => sum + (v.answer_count || 0),
            0
          )
        };
      })
      // Sort the main rows by total vehicles (like first snippet)
      .sort((a, b) =>
        isAsc ? a.totalVehicles - b.totalVehicles : b.totalVehicles - a.totalVehicles
      );
  
    setRowData(groupedData);
  }, [props.vehicleDeviceCombinationFilterData, sortBy]);
  
 

  
  
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 10 }}>
          <h3 className="spled-colored-label" style={{ fontSize: "20px", margin: 0 }}>
          Landing Page First time Users based on Vehicle Count
          </h3>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{ fontWeight: 500 }}>Sort By:</label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              style={{ padding: "5px 10px", borderRadius: 5 }}
            >
              <option value="">-- Select --</option>
              <option value="asc">Count(Low to High)</option>
              <option value="desc">Count(High to Low)</option>
             
            </select>
          </div>
        </div>
     <div style={{
  height: '50vh',
  display: 'flex',
  flexDirection: 'column',
  border: '1.5px solid #000',
  borderRadius: '12px',
  overflow: 'hidden',
  backgroundColor: '#ececec',
  fontFamily: 'sans-serif'
}}>
  
  {/* Table Header */}
  <div style={{ flexShrink: 0 }}>
    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
      <thead>
        <tr style={{ backgroundColor: '#77417f', color: '#ffffff' }}>
          <th style={{backgroundColor: '#77417f', color: '#fff', padding: '8px', textAlign: 'left', width: '200px'  }}>Resource Name</th>
          <th style={{backgroundColor: '#77417f', color: '#fff', padding: '8px', textAlign: 'left', width: '150px',textAlign:'right'  }}>FTCs</th>
          <th style={{ backgroundColor: '#77417f', color: '#fff', padding: '8px', textAlign: 'left', width: '200px'  }}>
            Vehicle 
            {/* <img
              alt=""
              src={ic_filter}
              height="20px"
              width="20px"
              style={{ marginLeft: '8px', verticalAlign: 'middle', cursor: 'pointer' }}
              onClick={() => props.handleVehicleDeviceFilterOpen()}
            />  */}
          </th>
          <th style={{backgroundColor: '#77417f', color: '#fff', padding: '8px', textAlign: 'left', width: '200px'  }}>Count</th>
        </tr>
      </thead>
    </table>
  </div>

  {/* Scrollable Body */}
  <div style={{ flexGrow: 1, overflowY: 'auto' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
    <tbody>
  {rowData.length > 0 && rowData.some(pm => 
    pm.ftc > 0 || pm.partners.some(partner => 
      partner.vehicleBreakdown.some(vehicle => vehicle.count > 0)
    )
  ) ? (
    rowData.map((pm, pmIndex) => {
      const totalVehicleRows = pm.partners.reduce(
        (acc, partner) => acc + (partner.vehicleBreakdown?.length || 0),
        0
      );

      return pm.partners.map((partner, partnerIndex) =>
        partner.vehicleBreakdown.map((vehicle, vehicleIndex) => {
          const isFirstVehicleForPM = partnerIndex === 0 && vehicleIndex === 0;
          const isFirstVehicleForPartner = vehicleIndex === 0;
          return (
            <tr key={`${pmIndex}-${partnerIndex}-${vehicleIndex}`} style={{ backgroundColor: '#fff' }}>
              {isFirstVehicleForPM && (
                <td rowSpan={totalVehicleRows} style={{ padding: '8px', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', width: '200px' }}>
                  {pm.programManager}
                </td>
              )}
              {isFirstVehicleForPartner && (
                <td rowSpan={partner.vehicleBreakdown.length} style={{ padding: '8px', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc',width: '150px',textAlign:'right' }}>
                  {pm.ftc}
                </td>
              )}
              <td style={{ padding: '8px', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc',width: '200px' }}>{vehicle.type}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #ccc',width: '200px' }}>{vehicle.count}</td>
            </tr>
          );
        })
      );
    })
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: 'center', padding: '18.3vh 0', color:'#555' }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

    </table>
  </div>

  {/* Footer Row */}
  <div style={{flexShrink: 0 }}>
    <table style={{ width: '100%',border: 'none', tableLayout: 'fixed' }}>
      <tfoot>
        <tr style={{ backgroundColor: '#77417f', color: '#fff' }}>
          <td style={{ width: '200px',border: 'none', backgroundColor: '#77417f', borderRadius: '0px' }}></td>
          <td style={{ width: '150px',border: 'none', backgroundColor: '#77417f' }}></td>
          <td style={{ width: '200px',border: 'none', backgroundColor: '#77417f' }}></td>
          <td style={{ width: '195px',border: 'none', fontWeight: 'bold', backgroundColor: '#77417f', borderRadius: '0px' }}>
          Total: {
  props.vehicleDeviceCombinationFilterData
    ?.reduce((total, item) => {
      return total + (item.answer_breakdown?.reduce((sum, row) => sum + row.answer_count, 0) || 0);
    }, 0) || 0
}          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

    </div>
  )
}

export default FTULandingPageVehicleData
